// extracted by mini-css-extract-plugin
export var afterNone = "style-module--after-none--d23f6";
export var content = "style-module--content--9aa43";
export var content_col = "style-module--content_col--9443d";
export var content_colDesc = "style-module--content_col-desc--4a5e8";
export var content_colIcon = "style-module--content_col-icon--3659f";
export var content_colIcon_block = "style-module--content_col--icon_block--fb1a6";
export var content_colName = "style-module--content_col-name--9ed00";
export var content_colNameMob = "style-module--content_col-name--mob--e16b0";
export var content_descBlock = "style-module--content_desc-block--0ca6b";
export var content_nameBlock = "style-module--content_name-block--765ba";
export var content_row = "style-module--content_row--caede";
export var content_rowFirst = "style-module--content_row--first--d3727";
export var content_title = "style-module--content_title--5377b";